import React, { useState } from 'react';
import { SnackbarProvider, useSnackbar } from "notistack";
import { useNavigate } from 'react-router-dom';
import { APIUrl } from '../../../Helper/APIUrl.js';


const LoginForm = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [Email, setemail] = useState("");
    const [Password, setpassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [focusedField, setFocusedField] = useState('');
    const [errors, setErrors] = useState({});


    const handleFocus = (fieldName) => {
        setFocusedField(fieldName);
    };

    const handleBlur = () => {
        setFocusedField('');
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent the default form submission
        login(); // Call the login function
    };

    const login = async (e) => {
        try {

            debugger;

            if (!Email || Email.length <= 2 || !Password || Password.length <= 2) {
                enqueueSnackbar("Enter a valid username and password", { variant: "warning" });
                return;
            }

            debugger;
            const response = await fetch(`${APIUrl.Ausers}ValidateAdminLogin`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Email, Password })
            });

            // handle non-2xx responses
            if (!response.ok) {
                const text = await response.text().catch(() => "");
                console.error("Login request failed", response.status, text);
                enqueueSnackbar("Login failed. Please try again.", { variant: "error" });
                return;
            }

            const result = await response.json();
            console.log("Login result:", result.data);
            if (result.Message === "Success") {
                localStorage.removeItem('lstCMenu');
                localStorage.removeItem('ParentIdlstCMenu');
                localStorage.removeItem('lstCMenuUserId');

                localStorage.setItem("userid", result.data.UserID);
                localStorage.setItem("username", result.data.UserName);                
                localStorage.setItem("roleid", result.data.RoleId);                
                localStorage.setItem("tcn", JSON.stringify(result.data.Token));                
                localStorage.setItem("Name", JSON.stringify(result.data.Name));                
                localStorage.setItem("Photo", JSON.stringify(result.data.Photo));                
                               
                enqueueSnackbar("Login successfull!", { variant: "success" });
                navigate("/dashboard");
            } else {
                enqueueSnackbar("Username and password are not valid", { variant: "warning" });
            }
        } catch (error) {
            console.error("Login error:", error);

            enqueueSnackbar("An error occurred. Kindly contact admin.", { variant: "error" });
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                {/* Header */}
                <div className="text-center">
                    <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-indigo-100 mb-4">
                        <svg className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                        Ask Me Reality
                    </h2>
                    <p className="text-gray-600 text-sm sm:text-base">
                        Please sign in to your account
                    </p>
                </div>

                {/* Login Form */}
                <div className="bg-white py-8 px-4 sm:px-8 shadow-xl rounded-2xl border border-gray-100">
                    <form className="space-y-6" onSubmit={handleSubmit}>

                        {/* Username Field */}
                        <div className="relative">
                            {/* <label
                                htmlFor="username"
                                className="block text-sm font-medium text-gray-700 mb-2"
                            >
                                Username
                            </label> */}
                            <input
                                id="username"
                                type="text"
                                required
                                maxLength={50}
                                value={Email}
                                onChange={(e) => setemail(e.target.value)}
                                onFocus={() => handleFocus('username')}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 sm:py-4 border rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none transition-all duration-300 ease-in-out ${focusedField === 'username'
                                    ? 'border-indigo-500 shadow-lg ring-4 ring-indigo-100 bg-indigo-50/30'
                                    : 'border-gray-300 bg-gray-50/50'
                                    }`}
                                placeholder="Username or Email"
                            />
                            <div className={`absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 transform transition-all duration-300 ease-in-out ${focusedField === 'username' ? 'scale-x-100' : 'scale-x-0'
                                }`}></div>
                        </div>

                        {/* Password Field */}
                        <div className="relative">

                            <input
                                id="password"
                                name="password"
                                type={showPassword ? 'text' : 'password'}
                                required
                                maxLength={25}
                                value={Password}
                                onChange={(e) => setpassword(e.target.value)}
                                onFocus={() => handleFocus('password')}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 sm:py-4 border rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none transition-all duration-300 ease-in-out ${focusedField === 'username'
                                    ? 'border-indigo-500 shadow-lg ring-4 ring-indigo-100 bg-indigo-50/30'
                                    : 'border-gray-300 bg-gray-50/50'
                                    }`}
                                placeholder="Password"
                            />


                            <button
                                type="button"
                                onClick={togglePasswordVisibility}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors duration-200 ml-2" // Added margin-left
                            >
                                {showPassword ? (
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                ) : (
                                    <i class="fa fa-eye-slash" aria-hidden="true"></i>
                                )}
                            </button>

                            <div className={`absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 transform transition-all duration-300 ease-in-out ${focusedField === 'password' ? 'scale-x-100' : 'scale-x-0'
                                }`}></div>
                        </div>

                        {/* Remember Me & Forgot Password */}
                        {/* <div className="flex items-center justify-between text-sm">
                            <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 transition-all duration-200"
                                />
                                <span className="ml-2 text-gray-600">Remember me</span>
                            </label>
                            <a href="#" className="text-indigo-600 hover:text-indigo-500 transition-colors duration-200 font-medium">
                                Forgot password?
                            </a>
                        </div> */}

                        {/* Submit Button */}
                        <button
                            type="submit"
                            className="group relative w-full flex justify-center py-3 sm:py-4 px-4 border border-transparent text-sm sm:text-base font-medium rounded-lg text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300 ease-in-out transform hover:scale-[1.02] hover:shadow-lg active:scale-[0.98]"
                        >
                            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                                <svg className="h-5 w-5 text-indigo-300 group-hover:text-indigo-200 transition-colors duration-200" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                </svg>
                            </span>
                            Sign in to your account
                        </button>




                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;